<template>
  <div>
    <m-table
      :page-model="pageModel"
      title="日志记录"
      resource="日志"
      :rules="{}"
      :create-button="false"
      title-key="id"
      border
      ref="table"
    >
      <template v-slot:default>
        <el-table-column label="ID" prop="id" width="100" header-align="center" align="center"></el-table-column>
        <el-table-column
          label="响应时间"
          prop="duration"
          width="100"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column label="响应码" prop="status" width="75" header-align="center" align="center"></el-table-column>
        <el-table-column label="请求类型" prop="type" width="100" align="center" header-align="center"></el-table-column>
        <el-table-column label="IP" prop="ip" width="150" align="center" header-align="center"></el-table-column>
        <el-table-column label="信息">
          <template slot-scope="{row}">
            <span v-if="row.is_request === 1">{{row.path}}</span>
            <span v-else>{{row.desc}}</span>
          </template>
        </el-table-column>
        <el-table-column label="记录等级" prop="level" width="100" align="center" header-align="center">
          <template slot-scope="{row}">
            <span v-if="row.level === 'INFO'" style="color:#409EFF">
              <i class="el-icon-info" />信息
            </span>
            <span v-if="row.level === 'DEBUG'" style="color:#67C23A">
              <i class="el-icon-warning-outline" />调试
            </span>
            <span v-if="row.level === 'WARN'" style="color:#E6A23C">
              <i class="el-icon-warning" />警告
            </span>
            <span v-if="row.level === 'ERROR'" style="color:#F56C6C">
              <i class="el-icon-error" />错误
            </span>
            <span v-if="row.level === 'FATAL'" style="color:#F56C6C">
              <i class="el-icon-remove" />致命
            </span>
          </template>
        </el-table-column>
        <el-table-column label="日志类型" align="center" header-align="center" width="150">
          <template slot-scope="{row}">{{row.is_request === 1 ? '请求记录': '系统记录'}}</template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="230"
          prop="created_at"
          align="center"
          header-align="center"
        ></el-table-column>
      </template>
      <template v-slot:search>
        <el-form :model="condition" ref="search">
          <el-row :gutter="5">
            <el-col :span="4">
              <el-form-item prop="is_request">
                <el-select v-model="condition.is_request" style="width:100%">
                  <el-option
                    v-for="(item,idx) in logTypes"
                    :key="idx"
                    :value="item.value"
                    :label="item.text"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="level">
                <el-select v-model="condition.level" style="width:100%">
                  <el-option
                    v-for="(item,idx) in levels"
                    :key="idx"
                    :value="item.value"
                    :label="item.text"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="tp">
                <el-select v-model="condition.tp" style="width:100%">
                  <el-option
                    v-for="(item,idx) in types"
                    :key="idx"
                    :value="item.value"
                    :label="item.text"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="begin_at">
                <el-date-picker
                  style="width:100%"
                  value-format="yyyy-MM-dd"
                  v-model="condition.begin_at"
                  type="date"
                  placeholder="过滤创建日期（大于等于）"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="end_at">
                <el-date-picker
                  style="width:100%"
                  value-format="yyyy-MM-dd"
                  v-model="condition.end_at"
                  type="date"
                  placeholder="过滤创建日期（小于等于）"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button
                icon="el-icon-search"
                type="primary"
                @click="$refs.table.confirmSearch(condition)"
              ></el-button>
              <el-button icon="el-icon-refresh" @click="$refs.search.resetFields()"></el-button>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </m-table>
  </div>
</template>

<script>
import Log from "../../models/Log";
import MTable from "../../components/table/index";
export default {
  components: { MTable },
  data: () => ({
    pageModel: new Log(),
    condition: {
      begin_at: null,
      end_at: null,
      tp: null,
      level: null,
      is_request: null
    },
    levels: [
      { text: "请选择记录类型", value: null },
      { text: "调试", value: "DEBUG" },
      { text: "信息", value: "INFO" },
      { text: "警告", value: "WARN" },
      { text: "错误", value: "ERROR" },
      { text: "致命", value: "FATAL" }
    ],
    types: [
      { text: "请选择请求类型", value: null },
      { text: "GET", value: "GET" },
      { text: "POST", value: "POST" },
      { text: "PUT", value: "PUT" },
      { text: "DELETE", value: "DELETE" }
    ],
    logTypes: [
      { text: "请选择日志类型", value: null },
      { text: "请求记录", value: 1 },
      { text: "系统记录", value: 0 }
    ]
  })
};
</script>

<style>
</style>